import { useEffect, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import { Card } from "react-bootstrap";

interface propData {
  data: any[];
  header: any[];
}

const InvoiceInfo = (props: propData) => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [headers, setHeader] = useState<GridHeader[]>([]);

  useEffect(() => {
    if (props.data && props.data.length > 0) {
      let rows: GridRow[] = [];
      for (var i in props.data) {
        let columns: GridColumn[] = [];
        for (var j in props.header) {
          columns.push({ value: props.data[i]["col" + (Number(j) + 1)] });
        }
        rows.push({ data: columns });
      }
      setRows(rows);
    }
  }, [props.data]);

  useEffect(() => {
    if (props.header && props.header.length > 0) {
      let header: GridHeader[] = [];
      for (var i in props.header) {
        header.push({
          title: props.header[i].headerName,
          class: props.header[i].headerAlignment == 'L' ? 'text-start' : props.header[i].headerAlignment == 'R' ? 'text-end' : "text-center",
        });
        setHeader(header);
      }
    }
  }, [props.header]);

  return (
    <>
      <Card
        className="card-style form-style invoice-call-picture-card p-3"
        style={{ marginBottom: 50 }}
      >
        {headers.length > 0 ?
          <Grid headers={headers} rows={rows} />
          : <></>}
        {headers.length == 0 &&
          <div className="error-message">No Invoice Detail Available</div>}
      </Card>
    </>
  );
};

export default InvoiceInfo;
